// import { Modal, ModalHeader, ModalBody } from "reactstrap";
// import { fundedInvoicesData } from "../../locales/en";
import PropTypes from "prop-types";
// import Style from "./modal.module.scss";

//{ isOpen, toggle }
const ManualUploadInvInfo = () => {
  return null;
  // <Modal
  //   isOpen={isOpen}
  //   toggle={toggle}
  //   className={`${Style.xeroModal} ${Style.manualUploadModal} modal-lg modal-dialog-centered`}
  // >
  //   <ModalHeader
  //     toggle={toggle}
  //     className={Style.creditModalHeader}
  //   ></ModalHeader>
  //   <ModalBody>
  //     <div className={`${Style.manualUploadContent} modal-content border-0`}>
  //       <div className="inv-upload-template flex-sm-wrap-reverse">
  //         <div
  //           className={`${Style.manul_Invoice_Submit}`}
  //           style={{ textAlign: "center" }}
  //         >
  //           <h2 className="mb-2">
  //             {fundedInvoicesData?.ManualUploadInvInfo?.title}
  //           </h2>
  //           <p>{fundedInvoicesData?.ManualUploadInvInfo?.subtitle1}</p>
  //           <p>{fundedInvoicesData?.ManualUploadInvInfo?.subtitle2}</p>
  //         </div>
  //       </div>
  //     </div>
  //   </ModalBody>
  // </Modal>
};
ManualUploadInvInfo.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired
};

export default ManualUploadInvInfo;
